import './public-path'
import Router from 'vue-router'
import Vuex from 'vuex'
import Vue from 'vue'
import I18n from 'vue-i18n'

import * as VueGoogleMaps from 'vue2-google-maps'
import { install } from '@/install'
import { createApp } from '@/app'

import '@utils/events'
import './js/bemto'
import './styles/index.sass'

import appComponents from './js/components'

Vue.use(VueGoogleMaps, {
  load: {
    key: window.googlekey,
    libraries: 'places',
  },
})

Vue.config.productionTip = false
Vue.use(install)
Vue.use(appComponents)

const { app } = createApp({
  Vue,
  I18n,
  Router,
  Vuex,
})

app.$mount('#app')
